var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('CompleteEnrollmentModal',{attrs:{"showCheckboxModal":_vm.showCheckboxModal},on:{"close":function($event){_vm.showCheckboxModal = false}}}),_c('DashboardComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }